import { Location } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { faBars, faTh } from "@fortawesome/free-solid-svg-icons";
import { UserRoles } from "src/app/models/enums/user-roles";
import { CommonService } from "src/app/services/common/common.service";
import { IllustrationService } from "src/app/services/illustration/illustration.service";
import { NetworkMembersService } from "src/app/services/network-members/network-members.service";
import { UserService } from "src/app/services/user.service";
import { AccountDto, IllustrationRequestDto, TasksStatus, } from "src/app/web-api-client";
import * as _ from "underscore";
import { UserAction } from "../../../models/enums/user-actions";
import { ProcessIds } from 'src/app/models/enums/processIds';

@Component({
  selector: "app-illustration-list",
  templateUrl: "./illustration-list.component.html",
  styleUrls: ["./illustration-list.component.scss"],
})
export class IllustrationListComponent implements OnInit {

  // hold the list of the illustrations
  illustrations: IllustrationRequestDto[] = [];

  // if the user is a networkmember or not
  isNetworkMember: boolean;
  isTableView: boolean;
  // input for pagination
  @Input() page: number = 1;
  @Input() pageSize: number = 30;

  // determine if the filter needs to be shown
  @Input() displayFilter: boolean = true;
  @Input() onOverview: boolean = false;
  @Input() isOnClientView: boolean = false;
  @Input() networkmember: AccountDto = null;
  // loading indicator
  loadingIllustrations: boolean = false;
  hideShowMoreBtn: boolean = false;

  params: ParamMap;
  clientName: string;

  isTableViewStoredValueKey: string;
  faTh = faTh;
  faBars = faBars;
  headers: { head: string, property: string }[] = [{ head: "Client", property: "title" }, { head: "Network Member", property: "networkMember?.accountName" }, { head: "Date", property: "displayDate" },{ head: "Country", property: "subtitle" }, { head: "Status", property: "status.value" }]
  // constructor
  constructor(
    public location: Location,
    private illustrationService: IllustrationService,
    private userService: UserService,
    private activatedroute: ActivatedRoute,
    private titleService: Title,
    private networkMembersService: NetworkMembersService,
    private commonService:CommonService
  ) { }

  // oninit method
  async ngOnInit(): Promise<void> {
    // determine if the user is a network member
    this.isNetworkMember = await this.userService.isUserInRole(UserRoles.NetworkMember);
    this.titleService.setTitle("All Illustrations | Insurope");
    // subscribe to the route params
    this.activatedroute.queryParamMap.subscribe(async (params) => this.loadIllustrations(params));
    this.isTableViewStoredValueKey = this.titleService.getTitle() + '_isTableView';

    //Log User Access
    this.commonService.logUserAction(UserAction.NavigateTo, "", ProcessIds.illustrations);

    if (this.isTableViewStoredValueKey) {
      let isTableView = localStorage.getItem(this.isTableViewStoredValueKey);
      var storedValue = JSON.parse(isTableView)
      if (isTableView) this.changeIsTableViewValue(storedValue);
      // set the title
    }
  }

  async loadMore() {
    if (!this.loadingIllustrations) {
      this.page++;
      await this.loadIllustrations(null, true);
    }

  }

  // method to get the illustrations
  async loadIllustrations(params?: any, loadMore?: boolean) {

    if (params) {
      this.params = params;
    }
    else {
      params = this.params;
    }

    let newItems;

    // loading started
    this.loadingIllustrations = true;

    if (params?.get("networkMemberId") && params.has("clientId")) {
      this.networkmember = await this.networkMembersService.getNetworkMemberById(params?.get("networkMemberId"));
    }
    var nmId = (params?.get("networkMemberId") ?? localStorage.getItem('networkMemberId'));
    var clientName = params?.get("clientName");
    var subscriberId = params?.get('subscriberId');
    var statusCode = localStorage.getItem('status');
    var status = TasksStatus[statusCode];
    var dueDate = localStorage.getItem('dueDate');
    if (subscriberId) {
      var subscriberEmail = (await this.userService.getUserById(subscriberId)).preferredEmail;
    }


    if (!loadMore) {
      this.illustrations = [];
      this.page = 1
    }

    if (this.isNetworkMember) {
      // load the illustrations
      newItems = await this.illustrationService.getMyOrganizationIllustrationsPaginated(
        clientName,
        status,
        subscriberId,
        subscriberEmail,
        parseInt(dueDate),
        null,
        null,
        this.page,
        this.pageSize
      );
    }
    else {
      if (!params.has('networkMemberId')) {
        // load the illustrations
        let networkMemberIDs: string[] = [];
        newItems = await this.illustrationService.getIllustrationsPaginated(
          networkMemberIDs,
          clientName,
          status,
          subscriberId,
          subscriberEmail,
          parseInt(dueDate),
          null,
          null,
          this.page,
          this.pageSize
        );
      }
      else {
        // load the illustrations
        let nmId = params?.get("networkMemberId") ? params?.get("networkMemberId") : localStorage.getItem('networkMemberId');
        let networkMemberIDs: string[] = [];
        if (!this.clientName && nmId) {
          networkMemberIDs.push(nmId);
        }
        newItems = await this.illustrationService.getIllustrationsPaginated(
          networkMemberIDs,
          clientName,
          status,
          subscriberId,
          subscriberEmail,
          parseInt(dueDate),
          null,
          null,
          this.page,
          this.pageSize
        );
      }
    }

    if (newItems.length < this.pageSize) {
      this.hideShowMoreBtn = true;
    } else {
      this.hideShowMoreBtn = false;
    }

    let updatedItems = newItems.map(illustration => {
      let updatedIllustration = illustration;

      // if (illustration.illustrationStage.name != "Finalized") {
      //   updatedIllustration.illustrationStage.name = "In-progress";
      // }

      return updatedIllustration;
    });

    this.illustrations = this.illustrations.concat(updatedItems);

    if (this.illustrations.length == 0) {
      document.getElementById("illustrations-view-btn")?.classList.add("d-none");
    }
    else {
      document.getElementById("illustrations-view-btn")?.classList.remove("d-none");
    }

    // loading finished
    this.loadingIllustrations = false;
  }

  changeIsTableViewValue(value: boolean) {
    if (value == null) {
      localStorage.setItem(this.isTableViewStoredValueKey, JSON.stringify(this.isTableView));
    } else {
      this.isTableView = value;
      localStorage.setItem(this.isTableViewStoredValueKey, JSON.stringify(value));
    }

    //Log switch view action
    if (value) {
      this.commonService.logUserAction(UserAction.SwitchToTableView, "", ProcessIds.illustrations);
    }
    else {
      this.commonService.logUserAction(UserAction.SwitchToCardView, "", ProcessIds.illustrations);
    }
  }

  replace(value: string, oldCharacter: string, newCharacter: string) {
    if (!value || !oldCharacter || !newCharacter) {
      return value;
    }

    return value.replace(oldCharacter, newCharacter);
  }

  getFinalizedSupportDate(illustration: IllustrationRequestDto): Date {
    var maxDate = new Date(_.max(illustration.illustrationRevisions.map(x => x.finalizedSupportDate)));
    return maxDate;
  }
}
